/**
 * 统一错误码（ARCH §7.2）
 * 所有 REST 接口失败时返回 { code, data:null, message }，code 取自下表
 */
export const ErrorCodes = {
    /** 成功 */
    OK: 0,
    /** 参数错误 */
    BAD_REQUEST: 40000,
    /** 未登录 / token 失效 */
    UNAUTHORIZED: 40001,
    /** 无权限（角色不足） */
    FORBIDDEN: 40002,
    /** 套餐未解锁该 Agent */
    AGENT_LOCKED: 40301,
    /** 配额不足（需升级） */
    QUOTA_EXCEEDED: 40302,
    /** 资源不存在 */
    NOT_FOUND: 40401,
    /** 重复操作（如重复注册/重复支付） */
    CONFLICT: 40901,
    /** 请求过于频繁（限流） */
    RATE_LIMITED: 42900,
    /** 系统内部错误 */
    INTERNAL_ERROR: 50000,
    /** 模型渠道全部不可用 */
    MODEL_UNAVAILABLE: 50301,
};
/** HTTP 状态码 -> 业务错误码 映射（供 AllExceptionsFilter 使用） */
export const HttpStatusToErrorCode = {
    400: ErrorCodes.BAD_REQUEST,
    401: ErrorCodes.UNAUTHORIZED,
    403: ErrorCodes.FORBIDDEN,
    404: ErrorCodes.NOT_FOUND,
    409: ErrorCodes.CONFLICT,
    429: ErrorCodes.RATE_LIMITED,
    500: ErrorCodes.INTERNAL_ERROR,
    503: ErrorCodes.MODEL_UNAVAILABLE,
};
